// filepath: apps/web/src/features/admin/fieldVisibility/RoleFieldVisibilityRoute.tsx
//
// FR-UI-ADM-4 — route shell for the admin viewer.
//
// URL: /admin/roles/{roleName}/field-visibility?entityType={entityType}
//
// The route shell:
//   - reads roleName from URL path and entityType from URL query
//     string;
//   - renders the RoleFieldVisibilityPage with the resolved
//     locale from i18n.
//
// The route does NOT gate on environmentKind — the admin viewer
// is read-only, so it does not require the staging-only guard
// that gates the FR-UI-ADM-1 matrix editor (per
// `01-requirement-validation.md` § "Scope Decision"). The AuthGuard
// wrapper in App.tsx covers authentication; the SPA never reads
// environmentKind for this surface.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";
import { RoleFieldVisibilityPage } from "./RoleFieldVisibilityPage";

interface RoleFieldVisibilityRouteProps {
  /** The target role name from the URL path. */
  roleName: string;
  /** The target entity type from the URL query string. */
  entityType: string;
}

/**
 * RoleFieldVisibilityRoute — read-only viewer shell. Parses the
 * URL params and renders the page.
 */
export function RoleFieldVisibilityRoute({
  roleName,
  entityType,
}: RoleFieldVisibilityRouteProps): React.ReactElement {
  const { locale } = useTranslation();
  return (
    <RoleFieldVisibilityPage
      roleName={roleName}
      entityType={entityType}
      locale={locale}
    />
  );
}
